import React, { FC } from 'react';
import { IRoute, IWaypoint } from '../../context/couriers';
import { useOrdersState } from '../../context/orders';
import OrderListItem from '../OrderListItem';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';

export enum CourierDetailOrderType {
  CURRENT = 'CURRENT',
  NEXT = 'NEXT',
}

export enum OrderPoolViewType {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

interface CourierDetailOrderPoolProps extends IRoute {
  inOrderPool: CourierDetailOrderType;
  viewType?: OrderPoolViewType;
}

export const CourierDetailOrderPool: FC<CourierDetailOrderPoolProps> = ({
  waypoints,
  inOrderPool,
  viewType = OrderPoolViewType.DESKTOP,
}) => {
  const { ordersById } = useOrdersState();
  const classes = useStyles();
  const { t } = useTranslation();

  const orderPoolTile = (tile: CourierDetailOrderType) => {
    switch (tile) {
      case CourierDetailOrderType.CURRENT:
        return (
          <div
            className={`${classes.upcommingDelivery} ${
              viewType === OrderPoolViewType.MOBILE ? 'mobile' : ''
            }`}
          >
            <JetFontIcon iconname={JET_FONTICON_ALIASES.FOOD} size={24} />{' '}
            {t('order.current_delivery')} ({waypoints.length})
          </div>
        );
      case CourierDetailOrderType.NEXT:
        return (
          <div
            className={`${classes.upcommingDelivery} ${
              viewType === OrderPoolViewType.MOBILE ? 'mobile' : ''
            }`}
          >
            <JetFontIcon iconname={JET_FONTICON_ALIASES.NACHOS} size={24} />{' '}
            {t('order.upcoming_delivery')} ({waypoints.length})
          </div>
        );
    }
  };
  return (
    <>
      {orderPoolTile(inOrderPool)}
      <ul className={classes.list}>
        {waypoints.map((item: IWaypoint, index: number) => {
          return (
            <OrderListItem
              sequence={index + 1}
              key={index}
              {...ordersById[item.order.uuid]}
            />
          );
        })}
      </ul>
    </>
  );
};
